<template>
  <div class="tabItem" @click="$emit('select', itemData.value)" v-bind:class="{ active: itemData.value == value }" >
		{{itemData.title}}
  </div>
</template>

<script>
export default {
  data () {
    return {
			
    }
  },
	props: {
		//标题
    itemData: {
      type: Object,
      required: true
    },
		value: {
			type: Number,
			default: 0
		}
  }
}
</script>

<style lang="less" scoped>
	@import "../../assets/theme.less";
	.tabItem{
		flex-grow:1;
		height:1rem;
		line-height:1rem;
		font-size:0.3rem;
		color:#666666;
		text-align:center;
		border-bottom:1px solid #e4e4e4;
	}
	.active{
		color:#27ba69;
		border-bottom:3px solid #27ba69;
	}
</style>


// WEBPACK FOOTER //
// tabItem.vue?f7298ac4